export default "__VITE_ASSET__Bz7QX9es__"